import type { Unit } from "@sins2-atlas/game-data";
import { clsx } from "clsx";
import {
  DLC_META,
  exclusiveFaction,
  OBTAINED_META,
  RACE_META,
  UNIT_KIND_LABELS,
} from "../lib/vocabulary";
import { Chip } from "./chip";

/** A unit's full facet-chip cluster — race (sigil + label), Class, faction exclusivity,
 * non-default Obtained, DLC — shared by the entity-page header and the comparison's unit
 * columns. The roster's name cell keeps its own smaller subset (race and Class are that
 * table's own columns). */
export function UnitFacetChips({ unit }: { unit: Unit }) {
  const race = RACE_META[unit.race];
  const exclusive = exclusiveFaction(unit);
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {/* The facet row wears the race chip wider and a shade brighter than the shared box,
          and its sigil keeps the sans face it has always drawn in — the chip's own mono
          renders the glyph narrower. */}
      <Chip
        label={race.label}
        className="gap-1.5 px-1.5 text-ink-2!"
        sigil={
          <span
            aria-hidden
            className={clsx("font-sans tracking-normal text-[9px]", race.textClass)}
          >
            {race.sigil}
          </span>
        }
      />
      <Chip label={UNIT_KIND_LABELS[unit.kind]} />
      {exclusive && (
        <Chip label={exclusive.short} title={`Only ${exclusive.full} can obtain this unit`} />
      )}
      {OBTAINED_META[unit.obtained].chipped && (
        <Chip
          label={OBTAINED_META[unit.obtained].label}
          title={OBTAINED_META[unit.obtained].title}
        />
      )}
      {unit.dlc && (
        <Chip
          label="DLC"
          title={DLC_META[unit.dlc].title}
          className="border-unverified/50 text-unverified"
        />
      )}
    </div>
  );
}
